var Session = /** @class */ (function () {
    function Session() {
    }
    return Session;
}());
export { Session };
